import Button from './form-fields/Button';
import Checkbox from './form-fields/Checkbox';
import Checklist from './form-fields/Checklist';
import Default from './form-fields/Default';
import EmailWidget from './form-fields/EmailWidget';
import FormComponent from './FormComponent';
import Number from './form-fields/Number';
import Radio from './form-fields/Radio';
import Select from './form-fields/Select';
import Taglist from './form-fields/Taglist';
import Text from './form-fields/Text';
import Textfield from './form-fields/Textfield';

export {
  Button,
  Checkbox,
  Checklist,
  Default,
  EmailWidget,
  FormComponent,
  Number,
  Radio,
  Select,
  Taglist,
  Text,
  Textfield
};

export const formFields = [
  Button,
  Checkbox,
  Checklist,
  Default,
  EmailWidget,
  Number,
  Radio,
  Select,
  Taglist,
  Text,
  Textfield
];